import Testimonial from './Testimonial'
import { CommentCall } from './CommentCall'
import { CarouselBlock } from '@onclicks/payload-types'
import RichText from '@onclicks/sharedcomponents/RichText'

const Testimonials: React.FC<CarouselBlock> = (data) => {
  const { slides, richText, links, title, background_media } = data
  const [featured, ...rest] = slides ?? []

  return (
    <section
      id="testimonials"
      aria-label="What our customers are saying"
      className="relative w-full bg-black px-6 py-20 text-white lg:px-16"
    >
      {/* Petit label du haut, encadré de deux traits */}
      <div className="mx-auto mb-14 flex max-w-xl items-center gap-4">
        <span className="h-px flex-1 bg-primary" />
        <span className="shrink-0 text-[11px] font-semibold tracking-[0.3em] text-white/70 uppercase">
          {title}
        </span>
        <span className="h-px flex-1 bg-primary" />
      </div>

      {richText && (
        <div className="mx-auto max-w-2xl text-center">
          <RichText data={richText} className="text-lg tracking-tight text-white/70" />
        </div>
      )}

      {links && (
        <div className="mt-6">
          <CommentCall data={links} />
        </div>
      )}

      {/* Témoignage mis en avant */}
      {featured && (
        <div className="mx-auto mt-4 max-w-3xl">
          <Testimonial testimonial={featured} featured />
        </div>
      )}

      {/* Témoignages secondaires, en ligne */}
      {rest.length > 0 && (
        <div className="mx-auto mt-16 flex max-w-6xl flex-col items-start justify-center gap-y-14 lg:flex-row lg:gap-x-12">
          {rest.map((testimonial, index) => (
            <div key={index} className="flex flex-1">
              <Testimonial testimonial={testimonial} />
            </div>
          ))}
        </div>
      )}
    </section>
  )
}

export default Testimonials
